import React, { useEffect } from "react";
import { useStore } from "../../store/store";
import { material as materialOptions } from "./defaults";
import allowedAlumAccess from "../../util/alumDealerList";
import { finAlumBifold, fin } from "../Fin/defaults";
import { UnitObj } from "../../util/quoteCartStorage";
import { useIsReadOnlyContextProviderContext } from "../../context/IsReadOnlyContext";

type UpdateObj = Partial<UnitObj>

const useMaterialSelector = (dealer: string, email: string) => {
  const addToQuote = useStore((state) => state.addToQuote);
  const materialChoice = useStore((state) => state.quote.material);
  const addDL = useStore((state) => state.quote.addDL);
  const doorType = useStore((state) => state.quote.doorType);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const configuration = useStore((state) => state.quote.configuration);
  const withHandle = useStore((state) => state.quote.withHandle);
  const headTrackColor = useStore((state) => state.quote.headTrackColor);
  const flashingFin = useStore((state) => state.quote.flashingFin);
  const { readOnly } = useIsReadOnlyContextProviderContext();

  useEffect(() => {
    if(materialChoice !== "All Aluminum") return

    if(doorType?.includes("Corner") || doorType?.includes("Combo")){
      const update: UpdateObj = {
        hingeColor: "",
        sillStyle: "",
        sillColor: "",
        stickingStops: "",
        weatherStripColor: "",
        handleStyle: "",
        handleColor: "",
        aluminumColor: "",
        aluminumColorExterior: "",
        splitFinish: "",
        shootBoltColor: ""
      }

      if(headTrackColor !== "Clear Anodized"){
        update.headTrackColor = ""
      }

      if(flashingFin){
        update.flashingFin = fin.label
      }

      addToQuote(update)
    }
  }, [materialChoice, doorType])

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    if (checked) return;

    let update: UpdateObj = {
      material: label,
      jamb: "",
      screenType: "",
      addScreen: "",
      screenPocket: "",
      screenColor: "",
      woodSpecies: "",
      stilesAndRails: "",
      stileCategory: "",
      lockRail: "",
      exteriorCladColor: "",
    };

    if (label === "All Wood" && addDL === "Add TDL") {
      update.addDL = "";
      update.liteConfig = "";
    }

    const isBifold = doorType?.includes("Bi-fold");

    if(materialChoice === "All Aluminum" && label !== "All Aluminum"){
      update.hingeColor = ""
      update.sillStyle = ""
      update.sillColor = ""
      update.stickingStops = "";
      update.weatherStripColor = "";
      update.handleStyle = ""
      update.handleColor = ""
      update.aluminumColor = ""
      update.aluminumColorExterior = ""
      update.splitFinish = ""
      update.shootBoltColor = ""

      if(headTrackColor !== "Clear Anodized"){
          update.headTrackColor = ""
        }

      if(isBifold && flashingFin){
        update.flashingFin = fin.label
      }
    }else if (label === "All Aluminum") {
      update.kerf = "";
      update.kerfConfig = "";
      update.kerfSetback = "";
      update.stickingStops = isBifold ? "Square" : "";
      update.stickingStopsExterior = "";
      update.stickingStopsInterior = "";
      update.paintAndPrime = "";
      update.prime = "";
      update.stain = "";
      update.customPaintOrStain = "";
      update.customPaintColor = "";
      update.customStainColor = "";
      update.stainColor = "";
      update.hingeColor = "Black"
      update.sillStyle = ""
      update.sillColor = ""
      update.exteriorCladColor = ""
      update.shootBoltColor = ""

      if (isBifold) {
        update.weatherStripColor = "Black";
        update.stilesRailsProfile = "Square";
        update.screenType = "Centor Flat Screen/Shade";

        if(withHandle === "Add Handle Set"){
          update.handleStyle = doorType === "Bi-fold Window" ? "" : "Touch Handle"
          update.handleColor = ""
        }

        if(headTrackColor !== "Clear Anodized"){
          update.headTrackColor = ""
        }

        if(flashingFin){
          update.flashingFin = finAlumBifold.label
        }

        if (configuration === "8L OR 8R") {
          update.exactConfig = "";
          update.configuration = "";
        }
      }

      if (
        exactConfig?.includes("Fixed") &&
        exactConfig !== "Fixed Full Bound"
      ) {
        update.exactConfig = "";
      }
    }

    addToQuote(update);
  };

  const variant = (label: string) =>
    label === materialChoice ? "filled" : "outlined";

  const checkMark = (label: string) => label === materialChoice;

  const showAlumOption = allowedAlumAccess(dealer, email);

  const options =
    (doorType === "Bi-fold" || doorType === "Bi-fold Window") && (showAlumOption || readOnly)
      ? materialOptions
      : materialOptions.filter((itm) => itm.label !== "All Aluminum");

  return {
    variant,
    checkMark,
    handleClick,
    options
  };
};

export default useMaterialSelector;
